module.exports = __webpack_public_path__ + "img/menuPianiWelfare.6f8c2663.jpg";